import { Injectable } from "@angular/core";

import { CreateApplicationRequestDto } from "../request/create-application-request.dto";

@Injectable({
  providedIn: "root",
})
export class ApplicationMapperService {
  createCreateApplicationRequest(
    quoteId: string,
    successExitPoint: URL,
    errorExitPoint: URL,
    declineExitPoint: URL,
    applicationPdfQrCodeUrl: URL,
  ) {
    const createApplicationRequest: CreateApplicationRequestDto = {
      quoteId: quoteId,
      successExitPoint: successExitPoint.toString(),
      errorExitPoint: errorExitPoint.toString(),
      declineExitPoint: declineExitPoint.toString(),
      applicationPdfQrCodeUrl: applicationPdfQrCodeUrl.toString(),
    };

    return createApplicationRequest;
  }
}
